import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { loadLanguageSet } from "@/services/lang-service";
import "@/assets/css/global.css";

loadLanguageSet("jpn");

createApp(App).use(router).mount('#app')
